// Sub-Admin Types
export const GET_SUB_ADMINS = "GET_SUB_ADMINS";
export const CREATE_SUB_ADMIN = "CREATE_SUB_ADMIN";
export const UPDATE_SUB_ADMIN = "UPDATE_SUB_ADMIN";
export const DELETE_SUB_ADMIN = "DELETE_SUB_ADMIN";
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const SET_SUB_ADMIN_LOADING = "SET_SUB_ADMIN_LOADING";
export const SUB_ADMIN_ERROR = "SUB_ADMIN_ERROR";